import React, { useState } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_REQUEST_EMAIL } from "../../pages/Login/LoginPage";

// DevExtreme components
import TextBox from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function LoginEmailReqest(props) {
  const { actionSuccessfull, actionError, cleanMessages, setIsLoading, isLoading, targetUri } = props;
  const requestFailedText = translate("loginEmailRequest.failed", "Register failed!");
  const requestSuccessText = translate("loginEmailRequest.success", "An Email has been send to: ");

  const [username, setUsername] = useState("");

  const loginChanged = e => {
    setUsername(e.value);
    cleanMessages();
  };

  async function requestLoginMail(args) {
    if (!args.validationGroup.validate().isValid) return;
    await requestLoginMailInternal(username);
    args.validationGroup.reset();
  }

  async function requestLoginMailInternal(usr) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchRequestLoginMail(usr, targetUri);
      if (result) throw new Error(result);
      actionSuccessfull(LOGINTYPE_REQUEST_EMAIL, null, requestSuccessText + usr);
      setIsLoading(false);
    } catch (error) {
      actionError(requestFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  return (
    <ValidationGroup>
      <LoginHeader title={translate("loginEmailRequest.title", "Request Login Mail")} description={translate("loginEmailRequest.description", "Type in your email address to receive a login")} />
      <div className={'dx-field'}>
        <TextBox
          value={username}
          onValueChanged={loginChanged}
          placeholder={translate("loginEmailRequest.textBoxEmailLabel", "Email")}
          disabled={isLoading}
          width={'100%'}
        >
          <Validator>
            <RequiredRule message={translate("loginEmailRequest.textBoxEmailError", "Email is required")} />
          </Validator>
        </TextBox>
      </div>
      <div className={'dx-field'}>
        <Button
          type={'default'}
          text={translate("loginEmailRequest.action", "Reset")}
          onClick={requestLoginMail}
          disabled={isLoading}
          width={'100%'}
        />
      </div>
    </ValidationGroup>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(LoginEmailReqest);
